export const commondata = {
    expbtn:{
        pt:"Explorar",
        eng:"Explore"
    }
}